<div class="hx-header" role="banner">
  <!-- Title Section -->
  <div class="hx-header__title">
    @if (title()) {
      <h3 class="hx-header__title-text text-reflow">{{ title() }}</h3>
    }
  </div>

  <!-- Actions Section -->
  <div class="hx-header__actions">
    <!-- Custom content from parent component -->
    <ng-content></ng-content>

    <!-- User Profile Section -->
    @if (hasUserProfile()) {
      <div class="hx-header__profile-section">
        <!-- Profile template for menu-button -->
        <ng-template #profileTemplate>
          <div class="hx-header__profile-content">
            @if (showStatus()) {
              <span
                class="hx-header__avatar-status"
                [class.hx-header__avatar-status--online]="isOnline()"
                [class.hx-header__avatar-status--offline]="!isOnline()"
                [hxTooltip]="connectivityTooltip()"
                position="bottom"
                role="status"
                [attr.aria-label]="connectivityTooltip()">
                <hx-avatar
                  size="sm"
                  [alt]="userProfile()?.name ?? 'User profile'"
                  [initials]="userProfile()?.initials"
                  [src]="userProfile()?.avatarUrl" />
              </span>
            } @else {
              <hx-avatar
                size="sm"
                [alt]="userProfile()?.name ?? 'User profile'"
                [initials]="userProfile()?.initials"
                [src]="userProfile()?.avatarUrl" />
            }
            <span class="hx-header__user-name text-reflow">{{ userProfile()?.name }}</span>
            @if (hasDropdown()) {
              <div class="hx-header__chevron-container">
                <hx-icon svgIcon="chevron-down" size="12" class="hx-header__chevron" inline="true"></hx-icon>
              </div>
            }
          </div>
        </ng-template>

        <!-- Single menu-button with custom template -->
        @if (hasDropdown()) {
          <hx-menu-button
            [config]="menuButtonConfig()"
            [buttonTemplate]="profileTemplate"
            (itemSelected)="onMenuItemClick($event.item, $event.index)"></hx-menu-button>
        } @else {
          <!-- Profile without dropdown - just clickable profile -->
          <button
            class="hx-header__profile-trigger"
            type="button"
            (click)="onProfileClick()"
            [attr.aria-label]="userProfile()?.name ?? 'User profile'"
            title="User profile">
            <ng-container [ngTemplateOutlet]="profileTemplate"></ng-container>
          </button>
        }
      </div>
    }
  </div>
</div>
